import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-shopify-details',
  templateUrl: './help-shopify-details.component.html',
  styleUrls: ['./help-shopify-details.component.scss']
})
export class HelpShopifyDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
